import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userOld from "./../../services/user/userService";

// Initial state setup
const createInitialState = () => ({
  data: null,
  error: null,
  status: "idle",
});

// Check user session thunk
export const checkUserSession = createAsyncThunk(
  "user/checkUserSession",
  async (_, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        return user; // Session is valid
      } else {
        throw new Error("No user found"); // No session found
      }
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// Login async thunk
export const loginAuth = createAsyncThunk(
  "loginAuth",
  async (initialPost, { rejectWithValue }) => {
    try {
      const response = await userOld.userLogin(initialPost);
      localStorage.removeItem("loginError");
      localStorage.setItem("user", JSON.stringify(response.data));
      if (response.data.role.role === 'admin') {
        localStorage.setItem('pageId', 2);
      } else if (response.data.role.role === 'teamlead') {
        localStorage.setItem('pageId', 1001);
      }
      return response.data;
    } catch (err) {
      localStorage.setItem("loginError", "The provided credentials are incorrect.");
      return rejectWithValue(err.response.data);
    }
  }
);

// Logout async thunk
export const logoutAuth = createAsyncThunk(
  "logoutAuth",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      // Perform necessary API calls to invalidate session if needed
      localStorage.removeItem("user");
      localStorage.removeItem("subPageId");
      localStorage.removeItem("search");
      localStorage.removeItem("pageId");
      localStorage.removeItem("studyId");
      dispatch(clearUser()); // Clear user state on successful logout

      // Trigger cross-tab logout
      localStorage.setItem("logout", Date.now());
    } catch (error) {
      console.error("Logout failed: ", error);
      return rejectWithValue(error.message);
    }
  }
);

// Initial state
const initialState = createInitialState();

// Create slice
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUser(state) {
      state.data = null;
      state.error = null;
      state.status = "idle";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkUserSession.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkUserSession.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(checkUserSession.rejected, (state) => {
        state.status = "failed";
        state.data = null;
      })
      .addCase(loginAuth.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(loginAuth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(logoutAuth.fulfilled, (state) => {
        state.status = "idle";
        state.data = null;
      });
  },
});

export const { clearUser } = userSlice.actions;
export default userSlice.reducer;
